var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BasicButton,{staticClass:"linear-cta",attrs:{"disabled":_vm.disabled}},[_c('div',{staticClass:"linear-cta__content"},[_c('span',{staticClass:"linear-cta__content__date"},[_vm._v(_vm._s(_setup.date))]),_c('span',{staticClass:"linear-cta__content__time"},[_vm._v(_vm._s(_setup.time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }